import { 
  IonText,
  IonCard,
  IonRow,
  IonCol,
  IonGrid,
} from '@ionic/react';
import Fade from 'react-reveal/Fade';

// Import Swiper React components
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, Keyboard } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
// import 'swiper/swiper.min.css'
// import 'swiper/modules/pagination/pagination.min.css'
// import 'swiper/modules/navigation/navigation.min.css'
// import 'swiper/modules/scrollbar/scrollbar.min.css'
// import 'swiper/modules/autoplay/autoplay.min.css'
// import 'swiper/modules/keyboard/keyboard.min.css'
import 'swiper/css/bundle'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const whyData = [
  {
      title: 'Additional cost savings',
      description: 'Save more by adding up to 6 stops in a single trip and avoid price surges with advanced trip booking.'
  },
  {
      title: 'Competitive prices',
      description: 'Get instant pricing information as you add your trip destinations.'
  },
  {
      title: 'Track your delivery in real time',
      description: 'Receive live updates on your driver’s location and the estimated time of arrival for your items.'
  },
  {
      title: 'Delivered by trusted driver-partners',
      description: 'Total Deliveries are fulfilled by private-hire, taxi, and carpool drivers who must adhere to our driver performance and community standards.'
  }
]

const WhyRydeSendMobile = () => {
  return(
      <div style={{maxWidth:'100vw', overflow:'hidden'}}>
      <IonRow style={{maxWidth:'1200px', width:'100%'}}>
          <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'flex-start', paddingLeft:'5%', maxWidth:'100%'}}>
              <Fade up>
              <IonText 
              className='font-baloo font-m font-semibold font-pink-1'
              style={{
              border:'none',
              height:'fit-content',
              marginLeft:'0px',
              }}>
                  Why RydeSEND?
              </IonText>
              </Fade>
          </IonCol>
      </IonRow>
      <Swiper
          style={{maxWidth:'100vw', overflow:'hidden', paddingBottom: '25px'}}
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay,Keyboard]}
          spaceBetween={225}
          slidesPerView={2.2}
          centeredSlides={true}
          autoplay={true}
          loop={true}
          duration={1000}
          keyboard={{enabled: true}}
          >
          {whyData.map((item, index) => {
              return(
                  <SwiperSlide key={index} 
                  style={{
                      display:'flex',
                      flexDirection:'column',
                      justifyContent:'center',
                      alignItems:'center',
                  }}
                  >
                  {({isActive}) => (
                      <IonCard 
                      style={{
                          background: isActive? '#f9f6f6':'white',
                          height: '15rem',
                          width: '258px',
                          display:'flex',
                          flexDirection:'column',
                          justifyContent:'flex-start',
                          alignItems:'flex-start',
                          borderRadius: '29px',
                          paddingLeft: '28px',
                          paddingRight: '17px',
                          paddingBottom: '18.35px'
                      }}>
                          <IonText 
                          className="font-bold font-baloo font-m"
                          style={{
                              marginTop:'1rem',
                              lineHeight: '1rem',
                          }}
                          >0{index+1}</IonText>
                          <IonText 
                          className="font-bold font-pink-1 font-baloo font-m"
                          style={{
                              marginBlock:'1.5rem',
                              lineHeight: '1rem'
                          }}
                          >{item.title}</IonText>
                          <IonText 
                          style={{
                              lineHeight: '1rem',
                          }}
                          className="font-baloo font-s"
                          >{item.description}</IonText>
                      </IonCard>
                  )}
                  </SwiperSlide>
              )
          }
          )}
      </Swiper>
      </div>
  )

  
}

const WhyRydeSendDesktop = () => {
  return(
      <div style={{
          // minHeight:'90vmax', 
          height:'fit-content', 
          overflow:'hidden',
          background:'#F9F6F6',
          paddingBlockEnd: '20px'
          // background:'#F9F6F6'
          }}>
      <IonGrid style={{
          height:'fit-content',
          // paddingBlock:'20px',
          // paddingBottom: '40px',
          display:'flex',
          flexDirection:'column',
          alignItems:'center',
      }}>
          <IonRow style={{
            maxWidth:'1200px', 
            width:'100%',
            marginBottom:'20px',
        }}>
              <IonCol style={{
                  display:'flex', 
                  flexDirection:'column', 
                  justifyContent:'center', 
                  alignItems:'flex-start', 
                  paddingLeft:'5%', 
                  maxWidth:'100%'}}>
                  <Fade up>
                  <IonText 
                  className="font-semibold font-baloo font-l"
                  style={{
                  border:'none',
                  color:'#E93864',
                  height:'fit-content',
                  marginLeft:'0px',
                  }}>
                      Why RydeSEND?
                  </IonText>
                  </Fade>
              </IonCol>
          </IonRow>
          {whyData.map((item, index) => {
              return(
                  <IonRow key={index} style={{maxWidth:'1200px', width:'100%'}}>
                      <IonCol style={{
                          display:'flex', 
                          flexDirection:'row', justifyContent:'space-between', alignItems:'center', 
                          marginInline: 'auto', 
                          height:'fit-content',
                          borderBottom: index<whyData.length-1?'1px solid #EDEDED':'',
                          maxWidth: '90%',
                          paddingBlock: '30px'
                      }}>
                      <Fade up>
                          <IonText 
                          style={{
                              padding:'5px', 
                              width:'fit-content',
                              lineHeight: '1.5rem',
                          }}
                          className="font-xl font-baloo font-semibold font-pink-1"
                          >
                              0{index+1}
                          </IonText>
                      </Fade>
                      <Fade up>
                          <div
                          style={{
                              display:'flex',
                              justifyContent:'flex-start',
                              width:'100%',
                              paddingInline:'20px'
                          }}
                          >
                              <IonText 
                              style={{
                                  lineHeight: '1.5rem',
                              }}
                              className="font-m font-regular font-pink-1 font-baloo"
                              >
                                  {item.title}
                              </IonText>
                          </div>
                      </Fade>
                      <Fade up>
                          <div
                          style={{
                              display:'flex',
                              justifyContent:'flex-start',
                              width:'100%',
                              paddingInline:'20px'
                          }}
                          >
                          <IonText 
                          style={{
                              lineHeight: '1rem',
                          }}
                          className="font-s font-baloo"
                          >
                              {item.description}
                          </IonText>
                          </div>
                      </Fade>
                      </IonCol>
                  </IonRow>
              )
          })}
      </IonGrid>
      </div>
  )
}

const WhySection = (userDevice) => {
  return (
    userDevice === 'mobile' ? WhyRydeSendMobile() : WhyRydeSendDesktop()
  )
}

export default WhySection